<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'UndoBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'undo',
      title: 'Undo',

      hotkey: ['ctrl+z', 'meta+z'],
    };
  },
  computed: {
    show() {
      return false;
    },
  },
  methods: {
    action() {
      this.undo();
    },
    undo() {
      this.canvas.undo();
    },
  },
};
</script>
